export const SERVER_PROP = 'server'
